import React, { useState } from 'react';
import { useDispatch } from "react-redux";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { Card, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { AlertFinalizadoStepper } from '../../../stepper/AlertFinalizadoStepper';
import { CUOTASFACTURACION_PERMISOS } from '../../../../utils/permisos';
import { validarSoloUnPermiso } from '../../../../helpers/permisos';
import { eliminarCuota, cuotasSeleccionar } from '../../../../actions/facturacion/cuotas';
import moment from "moment";

const style = {
    iconButton: {
        width: 32,
        height: 32,
        padding: 0,
        marginTop:0,
        marginBottom:0
    }
};

const optionsfecha = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
};

const formatFecha = fecha => {
    return new Date(fecha).toLocaleString(
        "es",
        optionsfecha
    );
}

export const ListaCuotas = (props) => {
    const dispatch = useDispatch();
    const { items, cargada } = props;
    const [ selected, setSelected ] = useState();
    const [ openQuestion, setOpenQuestion ] = useState(false);

    const handleEditItem = item => {
        dispatch( cuotasSeleccionar(item) );
    }

    const handleOpenQuestion = (item) => {
        setSelected(item);
        setOpenQuestion(true);
    }

    const handleClose = () => {
        resetValues();
    }

    const deleteCuota = () => {
        dispatch( eliminarCuota(selected.idCuota) );
        resetValues();
    }

    const resetValues = () => {
        setOpenQuestion(false);
        setSelected();
    }

    return (
        <>
            {cargada&&
                <Card>  
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell align="left"></TableCell>
                                    <TableCell align="left">Tipo Afiliacion</TableCell>
                                    <TableCell align="left">Sit. Revista Aportes</TableCell>
                                    <TableCell align="left">Descripcion</TableCell>
                                    <TableCell align="left">Edad Desde</TableCell>
                                    <TableCell align="left">Edad Hasta</TableCell>
                                    <TableCell align="left">Fecha Desde</TableCell>
                                    <TableCell align="left">Fecha Hasta</TableCell>
                                    <TableCell align="center">Cuota</TableCell>
                                    <TableCell align="center">Cuota Familiar</TableCell>
                                    <TableCell align="left"></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items.length > 0
                                    ?
                                        items
                                            .slice(props.page * props.rowsPerPage, props.page * props.rowsPerPage + props.rowsPerPage)
                                            .map((item) => {

                                                return (
                                                    <TableRow key={item.idCuota}>
                                                        <TableCell align="left">
                                                            <IconButton style={{ padding: 0, margin:0 }}
                                                                color="primary"
                                                                aria-label="Editar"
                                                                onClick={(e) => handleEditItem(item)}
                                                                disabled={!validarSoloUnPermiso(props.permisosUser, CUOTASFACTURACION_PERMISOS.MODIFICACION)}
                                                            >
                                                                <EditIcon style={style.iconButton} />
                                                            </IconButton>
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {item.tipoAfiliacion.descripcion_afiliacion}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {item.sitRevistaAportes}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {item.descripcion}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {item.edadDesde}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {item.edadHasta}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {formatFecha(item.fechaDesde)}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {moment(moment(item.fechaHasta).format('YYYY-MM-DD')).isSame(moment('3000-12-31')) ? 'Actual' : formatFecha(item.fechaHasta)}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {`$${item.cuota.toFixed(2)}`}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {`$${item.cuotaFamiliar.toFixed(2)}`}
                                                        </TableCell>
                                                        <TableCell>
                                                            <IconButton 
                                                                style={{ padding: 0, margin: 0 }}
                                                                onClick={(e) => handleOpenQuestion(item)}
                                                                disabled={!validarSoloUnPermiso(props.permisosUser, CUOTASFACTURACION_PERMISOS.BAJA)}
                                                                color="primary"
                                                                aria-label="seleccionar"
                                                            >
                                                                <DeleteIcon />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                            )
                                        })
                                    :
                                        <TableRow style={{ height: 50 }}>
                                            <TableCell colSpan={8} style={{textAlign: '-webkit-center'}}> Sin Registros</TableCell>
                                        </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    {openQuestion && 
                        <AlertFinalizadoStepper
                            open={openQuestion}
                            pregunta={"Eliminar Cuota"}
                            dialogText={`Se va a eliminar la cuota ${selected.norma} que va desde el ${formatFecha(selected.fechaDesde)} hasta el ${formatFecha(selected.fechaHasta)}, está seguro?`}
                            buttonCancel={"Cancelar"}
                            buttonSubmit={"Continuar"}
                            handleClose={handleClose}
                            handleSend={deleteCuota}
                        />
                    }  
                </Card>
            }  
        </>
     );
}